import cashDropSvg from '../../assets/icons/casino/game-tags/cashDrop.svg';
import exclusiveSvg from '../../assets/icons/casino/game-tags/exclusive.svg';
import freeSpinsSvg from '../../assets/icons/casino/game-tags/freeSpins.svg';
import networkPromotionSvg from '../../assets/icons/casino/game-tags/networkPromotion.svg';
import newGameSvg from '../../assets/icons/casino/game-tags/newGame.svg';
import popularSvg from '../../assets/icons/casino/game-tags/popular.svg';
import tournamentSvg from '../../assets/icons/casino/game-tags/tournament.svg';
import { CASINO_FILTER_NAME } from '../../international/translation/casinoFilters';
import {
  CASINO_GAME_TAG_AMBER,
  CASINO_GAME_TAG_DARK_BLUE,
  CASINO_GAME_TAG_GREEN,
  CASINO_GAME_TAG_ORANGE,
  CASINO_GAME_TAG_PURPLE,
  CASINO_GAME_TAG_RED,
} from '../../theme';
import { CASINO_CATEGORY_IDS, CASINO_CATEGORY_NAMES, CASINO_CATEGORY_PATH_NAMES, CASINO_TAG_ID, CASINO_TAG_NAME } from './casinoEnums';
import { CasinoGameTagDisplayInfo } from './casinoInterfaces';

export const nativeAppHotLink =
  'https://dkn33.app.goo.gl/?link=http%3A%2F%2Fkwiff.com%2Fapp%2Fsports&apn=gaming.eatongate.com.kwiffapp&isi=1116593875&ibi=com.kwiff.kwiff&efr=1';

export const NETENT_LIBRARY_SRC_TEST = 'https://kwiff-static-test.casinomodule.com/gameinclusion/library/gameinclusion.js';
export const NETENT_STATIC_SERVER_URL_TEST = 'https://kwiff-static-test.casinomodule.com/';
export const NETNET_GAME_SERVER_URL_TEST = 'https://kwiff-game-test.casinomodule.com/';

export const NETENT_LIBRARY_SRC_PROD = 'https://kwiff-static.casinomodule.com/gameinclusion/library/gameinclusion.js';
export const NETENT_STATIC_SERVER_URL_PROD = 'https://kwiff-static.casinomodule.com/';
export const NETNET_GAME_SERVER_URL_PROD = 'https://kwiff-game.casinomodule.com/';

export const KWIFF_PICKS = 'kwiff picks';

export const BESPOKE_RECOMMENDATIONS_GAMES_LIMIT = 10;
export const MIN_CASINO_SEARCH_TERM_LENGTH = 2;

export const tileVariants = {
  SM_WD: 'SM-WD',
  SM_TL: 'SM-TL',
  WD: 'WD',
  TL: 'TL',
  SQ: 'SQ',
  SQ_SM: 'SQ-SM',
  SQ_BIG: 'SQ-BIG',
  CL: 'CL',
  CL_BIG: 'CL-BIG',
  IG: 'IG',
};

export const EVOLUTION_GAMES_PROVIDER_ID = 2;
export const NETENT_PROVIDER_ID = 6;

export const JACKPOT_FIXED_TEXT_SIZE_REDUCTION = 15;
export const JACKPOT_THRESHOLD_TO_TRIGGER_TEXT_CHANGE = 0.1;
export const JACKPOT_MAX_FONT_SIZE = 26;

export const CLOSE_CASINO_GAME_COMMAND = 'closeGame';

export const CASINO_CATEGORY_PATH_NAME_MAP = [
  {
    categoryId: CASINO_CATEGORY_IDS.FEATURED,
    pathName: CASINO_CATEGORY_PATH_NAMES.FEATURED,
  },
  {
    categoryId: CASINO_CATEGORY_IDS.SLOTS,
    pathName: CASINO_CATEGORY_PATH_NAMES.SLOTS,
  },
  {
    categoryId: CASINO_CATEGORY_IDS.LIVE_CASINO,
    pathName: CASINO_CATEGORY_PATH_NAMES.LIVE_CASINO,
  },
  {
    categoryId: CASINO_CATEGORY_IDS.TABLE_GAMES,
    pathName: CASINO_CATEGORY_PATH_NAMES.TABLE_GAMES,
  },
  {
    categoryId: CASINO_CATEGORY_IDS.VIRTUAL_SPORTS,
    pathName: CASINO_CATEGORY_PATH_NAMES.VIRTUAL_SPORTS,
  },
];

export const CASINO_CATEGORY_ID_NAME_MAP = [
  {
    id: CASINO_CATEGORY_IDS.FEATURED,
    name: CASINO_CATEGORY_NAMES.FEATURED,
  },
  {
    id: CASINO_CATEGORY_IDS.SLOTS,
    name: CASINO_CATEGORY_NAMES.SLOTS,
  },
  {
    id: CASINO_CATEGORY_IDS.LIVE_CASINO,
    name: CASINO_CATEGORY_NAMES.LIVE_CASINO,
  },
  {
    id: CASINO_CATEGORY_IDS.TABLE_GAMES,
    name: CASINO_CATEGORY_NAMES.TABLE_GAMES,
  },
  {
    id: CASINO_CATEGORY_IDS.VIRTUAL_SPORTS,
    name: CASINO_CATEGORY_NAMES.VIRTUAL_SPORTS,
  },
];

export const MAX_NUMBER_OF_CASINO_TAGS_TO_DISPLAY = 4;

export const CASINO_GAME_TAGS: CasinoGameTagDisplayInfo[] = [
  {
    id: CASINO_TAG_ID.POPULAR,
    icon: popularSvg,
    colour: CASINO_GAME_TAG_AMBER,
    name: CASINO_TAG_NAME.POPULAR,
    nameId: 'casino.tags.popular.name',
    descriptionId: 'casino.tags.popular.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.NEW,
    icon: newGameSvg,
    colour: CASINO_GAME_TAG_DARK_BLUE,
    name: CASINO_TAG_NAME.NEW,
    nameId: 'casino.tags.new.name',
    descriptionId: 'casino.tags.new.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.NETWORK_PROMOTION,
    icon: networkPromotionSvg,
    colour: CASINO_GAME_TAG_ORANGE,
    name: CASINO_TAG_NAME.NETWORK_PROMOTION,
    nameId: 'casino.tags.network_promotion.name',
    descriptionId: 'casino.tags.network_promotion.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.EXCLUSIVE,
    icon: exclusiveSvg,
    colour: CASINO_GAME_TAG_RED,
    name: CASINO_TAG_NAME.EXCLUSIVE,
    nameId: 'casino.tags.exclusive.name',
    descriptionId: 'casino.tags.exclusive.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.TOURNAMENT,
    icon: tournamentSvg,
    colour: CASINO_GAME_TAG_ORANGE,
    name: CASINO_TAG_NAME.TOURNAMENT,
    nameId: 'casino.tags.tournament.name',
    descriptionId: 'casino.tags.tournament.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.CASH_DROP,
    icon: cashDropSvg,
    colour: CASINO_GAME_TAG_GREEN,
    name: CASINO_TAG_NAME.CASH_DROP,
    nameId: 'casino.tags.cash_drop.name',
    descriptionId: 'casino.tags.cash_drop.info',
    callToActionId: 'casino.tags.check_it_out',
  },
  {
    id: CASINO_TAG_ID.FREE_SPINS,
    icon: freeSpinsSvg,
    colour: CASINO_GAME_TAG_PURPLE,
    name: CASINO_TAG_NAME.FREE_SPINS,
    nameId: 'casino.tags.free_spins.name',
    descriptionId: 'casino.tags.free_spins.info',
    callToActionId: 'casino.tags.check_if_you_are_eligible',
  },
];

export const CASINO_FILTERS_FOR_REORDERING = {
  MOST_POPULAR: {
    name: CASINO_FILTER_NAME.HOME_MOST_POPULAR,
    id: 4,
  },
  KWIFF_PICKS: {
    name: CASINO_FILTER_NAME.KWIFF_PICKS,
    id: 3,
  },
  NEW_GAMES: {
    name: CASINO_FILTER_NAME.NEW_GAMES,
    id: 161,
  },
  RECENTLY_PLAYED: {
    name: CASINO_FILTER_NAME.RECENTLY_PLAYED,
    id: undefined,
  },
};
